export const PRODUCT_BAG_CODE = 26790;
